import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '@/utils/api'
import { API_ROUTES } from '@/const/apiRoutes'

export const useMembersStore = defineStore('members', () => {
  const adventurers = ref<any[]>([])
  const guides = ref<any[]>([])
  const isAdventurersLoading = ref(false)
  const isGuidesLoading = ref(false)
  const adventurersError = ref<string | null>(null)
  const guidesError = ref<string | null>(null)
  const manageExpeditionMembersError = ref<string | null>(null)
  const manageExpeditionMembersLoading = ref(false)

  const fetchExpeditionAdventurers = async (expeditionId: string) => {
    isAdventurersLoading.value = true
    adventurersError.value = null

    try {
      const response = await api.get(API_ROUTES.GET_ADVENTURERS_BY_EXPEDITION_ID(expeditionId))
      if (Array.isArray(response.data) && response.data.length > 0) {
        adventurers.value = response.data
      } else {
        adventurers.value = []
      }
    } catch (err: any) {
      adventurersError.value = err.response?.data?.message || 'Failed to fetch adventurers'
    } finally {
      isAdventurersLoading.value = false
    }
  }

  const fetchExpeditionGuides = async (expeditionId: string) => {
    isGuidesLoading.value = true
    guidesError.value = null

    try {
      const response = await api.get(API_ROUTES.GET_GUIDES_BY_EXPEDITION_ID(expeditionId))
      if (Array.isArray(response.data) && response.data.length > 0) {
        guides.value = response.data
      } else {
        guides.value = []
      }
    } catch (err: any) {
      guidesError.value = err.response?.data?.message || 'Failed to fetch guides'
    } finally {
      isGuidesLoading.value = false
    }
  }

  const manageExpeditionMembers = async (expeditionId: string, adventurers: any[], guides: any[], mainGuideId?: number | null) => {
    console.log('Store action manageExpeditionMembers entered', { expeditionId, adventurers, guides, mainGuideId });
    manageExpeditionMembersLoading.value = true
    manageExpeditionMembersError.value = null

    try {
      // Map user/guide objects to their IDs for the payload
      const adventurersIds = adventurers.map((user: any) => user.id);
      const guidesIds = guides.map((guide: any) => guide.id);
      await api.put(API_ROUTES.MANAGE_EXPEDITION_MEMBERS(expeditionId), {
        adventurers: adventurersIds,
        guides: guidesIds,
        main_guide: typeof mainGuideId === 'number' ? mainGuideId : null,
      }) 
    } catch (err: any) {
      manageExpeditionMembersError.value = err.response?.data?.message || 'Failed to manage expedition members'
    } finally {
      manageExpeditionMembersLoading.value = false
    }
  }

  return {
    fetchExpeditionAdventurers,
    fetchExpeditionGuides,
    adventurers,
    guides,
    isAdventurersLoading,
    isGuidesLoading,
    adventurersError,
    guidesError,
    manageExpeditionMembers,
    manageExpeditionMembersLoading,
    manageExpeditionMembersError
  }
})
